import Link from '@mui/material/Link'

import { RouterLink } from 'src/routes/components'

export function FormReturnLink({ sx, to, label, onClick, children, ...other }) {
  const params = to ? { to, component: RouterLink } : { onClick }
  return (
    <Link
      {...params}
      color='inherit'
      variant='subtitle2'
      sx={[
        {
          cursor: 'pointer',
          mt: 3,
          gap: 0.5,
          mx: 'auto',
          alignItems: 'center',
          display: 'inline-flex'
        },
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...other}
    >
      {label}
      {children}
    </Link>
  )
}
